import { memo } from 'react';
import classnames from 'classnames';

import styles from './Cta.module.scss';

import BaseButton, { BaseButtonProps } from '../BaseButton/BaseButton';
import BaseLink, { BaseLinkProps } from '../BaseLink/BaseLink';

export type Props = BaseButtonProps | BaseLinkProps;

const isLink = (props: Props): props is BaseLinkProps => {
  // check if the specified property has href
  return 'href' in props;
};

function Cta(props: Props) {
  return (
    <>
      {isLink(props) ? (
        <BaseLink {...props} className={classnames(props.className, styles.Cta)}>
          {props.title}
        </BaseLink>
      ) : (
        <BaseButton {...props} className={classnames(props.className, styles.Cta)}>
          {props.title}
        </BaseButton>
      )}
    </>
  );
}

export default memo(Cta);
